<template>
  <div class="start-check">
    <head-top :head-title="upName" hidden='true' go-back="true"></head-top>
    <div class="content">
      <div @click="StartCheck(item.category_id, item.category_name, relatedId, $route.params.liftNum, item.id, $route.params.id)" v-for="(item,index) in listData" :key="index">
        <mt-cell is-link :title="item.category_name">
          <span style="color: #666;" v-show="item.status === 1">已查验</span>
          <span style="color: #0078de;" v-show="item.status === 0">未查验</span>
          <span style="color: #0078de;" v-show="item.status === 1">编辑</span>
        </mt-cell>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from '../header/Header.vue'
import {getCheckContent} from '../../api/jianli.js'

export default {
  name: 'StartCheck',
  data() {
    return {
      listData: [],
      relatedId: '',
      upName: ''
    }
  },
  components: {
    headTop
  },
  created() {
    this._getCheckContent()
  },
  methods: {
    _getCheckContent() {
      getCheckContent(this.$route.params.id, this.$route.params.liftNum, this.$route.params.name).then(res => {
        if (res.code === 200) {
          this.listData = res.data.data
          this.relatedId = res.data.related_id
          this.upName = res.data.up_name
          console.log(this.listData)
        }
      })
    },
    StartCheck(id, name, relatedId, liftNum, hid, mainid) {
      var urlname = encodeURIComponent(name)
      // console.log(urlname)
      window.location.href = `/GoCheckPublish/${id}/${urlname}/${relatedId}/${liftNum || 0}/${hid}/${mainid}`
    }
  }
}
</script>

<style lang="scss">
  .start-check{
    .content{
      padding-top: 40px;
      .mint-cell:last-child{
        background-size: 100% 0px;
      }
      .mint-cell-value{
        span{
          font-size: 13px;
          margin-right: 5px;
        }
      }
      .mint-cell-value.is-link {
        margin-right: 10px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/content/StartCheck.vue